import {
  cardTitleTextClass,
  insetSurfaceCardClass,
} from "@/components/common/surfaceClasses";
import type { SpeakMode } from "@/lib/speech/voiceSettings";
import {
  setSpeakMode as persistSpeakMode,
  setVoiceEnabled as persistVoiceEnabled,
  setVoiceProvider as persistVoiceProvider,
} from "@/lib/speech/voiceSettings";

type Props = {
  voiceEnabled: boolean;
  setVoiceEnabled: (v: boolean) => void;
  voiceProvider: "system" | "custom";
  setVoiceProvider: (v: "system" | "custom") => void;
  speakAnswers: boolean;
  canSpeakHelp: boolean;
  setSpeakMode: (m: "answers" | "help" | "all") => void;
};

export function ProfileEditorVoiceBlock({
  voiceEnabled,
  setVoiceEnabled,
  voiceProvider,
  setVoiceProvider,
  speakAnswers,
  canSpeakHelp,
  setSpeakMode,
}: Props) {
  return (
    <div className={`mt-2 ${insetSurfaceCardClass}`}>
      <div className={`text-xs font-semibold mb-2 ${cardTitleTextClass}`}>Voice settings</div>

      <label className={`flex items-center gap-2 text-sm ${cardTitleTextClass}`}>
        <input
          type="checkbox"
          checked={voiceEnabled}
          onChange={(e) => {
            const next = e.target.checked;
            setVoiceEnabled(next);
            persistVoiceEnabled(next);
          }}
        />
        Voice Enabled
      </label>

      <div className="mt-3">
        <div className="text-xs font-semibold text-gray-600 mb-1">Voice quality</div>
        <div className="flex flex-wrap gap-4">
          <label className="flex items-center gap-2 text-sm text-gray-800">
            <input
              type="radio"
              name="bb-voice-provider"
              value="system"
              checked={voiceProvider === "system"}
              onChange={() => {
                setVoiceProvider("system");
                persistVoiceProvider("system");
              }}
            />
            System
          </label>

          <label className="flex items-center gap-2 text-sm text-gray-800">
            <input
              type="radio"
              name="bb-voice-provider"
              value="custom"
              checked={voiceProvider === "custom"}
              onChange={() => {
                setVoiceProvider("custom");
                persistVoiceProvider("custom");
              }}
            />
            Custom
          </label>
        </div>
      </div>

      <label className="mt-3 flex items-center gap-2 text-sm text-gray-800">
        <input
          type="checkbox"
          checked={speakAnswers}
          onChange={(e) => {
            const next = e.target.checked;
            const nextMode: SpeakMode = next ? "answers" : "help";
            setSpeakMode(nextMode);
            persistSpeakMode(nextMode);
          }}
          disabled={!canSpeakHelp}
        />
        Speak Answers
      </label>
    </div>
  );
}
